import React, { Component } from 'react';
import PropTypes from 'prop-types';


import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';

import { StyledBlockWrapper } from './styles/StyledBlockWrapper';


class DataWrapper extends Component {
  render() {
    const { isLoading, status, children, minHeight, errorMessage, isLoadingText, spinnerFat, spinnerSize, textSizeLoading, textSizeError } = this.props;

    if (isLoading) {
      return (
        <StyledBlockWrapper 
          setMinHeight={true}
          minHeight={minHeight}
        >

          <LoadingSpinner 
            text={isLoadingText}
            textSize={textSizeLoading}
            spinnerSize={spinnerSize}
            spinnerFat={spinnerFat}
          />

        </StyledBlockWrapper>      
      );
    }

    if (!status) {
      return (
       <StyledBlockWrapper 
          setMinHeight={true}
          minHeight={minHeight}
        >

          <ErrorScreen
            title={errorMessage}
            textSize={textSizeError}
          />

        </StyledBlockWrapper>    
      );
    }

    return (
      <div>
        { children }
      </div>
    );
  }
}


DataWrapper.defaultProps = {
  errorMessage: 'Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později.',
  isLoadingText: 'Obsah se načítá',
};



DataWrapper.propTypes = {
  errorMessage: PropTypes.string,
  isLoadingText: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  status: PropTypes.bool.isRequired,
  minHeight: PropTypes.number.isRequired,
  spinnerFat: PropTypes.number,
  spinnerSize: PropTypes.number,
  textSizeLoading: PropTypes.number,
  textSizeError: PropTypes.number,
};


export default DataWrapper;